import {
  START_LOADING,
  END_LOADING,
  CREATE_COMPANY,
  UPDATE_COMPANY,
  DELETE_COMPANY,
  FETCH_COMPANY,
  FETCH_COMPANY_PUBLIC_DETAILS,
  FETCH_COMPANIES,
} from "../actions/constants";

const companies = (
  state = { isLoading: false, companies: [], category: "", barcodeItems: null },
  action
) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_COMPANIES:
      return {
        ...state,
        companies: action.payload.companies,
        numberOfPages: action.payload.numberOfPages,
      };
    case FETCH_COMPANY_PUBLIC_DETAILS:
      return { ...state, company: action.payload };
    case FETCH_COMPANY:
      return { ...state, company: action.payload };
    case CREATE_COMPANY:
      return { ...state, companies: [...state.companies, action.payload] };
    case UPDATE_COMPANY:
      return {
        ...state,
        companies: state.companies.map((company) =>
          company._id === action.payload._id ? action.payload : company
        ),
        company:
          action.payload._id === state.company._id
            ? action.payload
            : state.company,
      };
    case DELETE_COMPANY:
      return {
        ...state,
        companies: state.companies.filter(
          (company) => company._id !== action.payload
        ),
      };
    default:
      return state;
  }
};

export default companies;
